export default [{
  "name": "A",
  "crosses": [],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Am",
  "crosses": [],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 3, "y": 1.5, "text": "3"}, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "A5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 3, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "A7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 4, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "A7sus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 4, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Am7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Amaj7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 3, "y": 0.5, "text": "1"}, {"x": 4, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "A6",
  "crosses": [{"x": 0, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 2, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Asus2",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 3, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Asus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Adim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 1.5, "text": "3"}, {
    "x": 4,
    "y": 0.5,
    "text": "2"
  }, {"x": 5, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Aaug",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "4"}, {"x": 3, "y": 1.5, "text": "2"}, {
    "x": 4,
    "y": 1.5,
    "text": "3"
  }, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Am6",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 3, "y": 1.5, "text": "3"}, {
    "x": 4,
    "y": 0.5,
    "text": "1"
  }, {"x": 5, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "A9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 5, "y": 2.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 4, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Aadd9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 3.5, "text": "4"}, {"x": 4, "y": 1.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "A/C#",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 1, "y": 3.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 1.5}, "end": {"x": 4, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "A/E",
  "crosses": [{"x": 0, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 2, "y": 1.5}, "end": {"x": 4, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bb",
  "crosses": [{"x": 0, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}, {
    "text": 3,
    "start": {"x": 2, "y": 2.5},
    "end": {"x": 4, "y": 2.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbm",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "4"}, {"x": 4, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bb5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 1, "y": 0.5, "text": "1"}, {"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bb7",
  "crosses": [],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 4, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bb7sus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbm7",
  "crosses": [],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 4, "y": 1.5, "text": "2"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 3, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbmaj7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bb6",
  "crosses": [],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 1, "y": 0.5}}, {
    "text": 3,
    "start": {"x": 2, "y": 2.5},
    "end": {"x": 5, "y": 2.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbsus2",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "2"}, {"x": 3, "y": 2.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbsus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "2"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 3.5,
    "text": "4"
  }, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbdim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbaug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "4"}, {"x": 3, "y": 2.5, "text": "2"}, {
    "x": 4,
    "y": 2.5,
    "text": "3"
  }, {"x": 5, "y": 1.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbm6",
  "crosses": [],
  "points": [{"x": 4, "y": 1.5, "text": "2"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 1, "y": 0.5}}, {
    "text": 3,
    "start": {"x": 2, "y": 2.5},
    "end": {"x": 3, "y": 2.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bb9",
  "crosses": [],
  "points": [],
  "lines": [{"text": 2, "start": {"x": 0, "y": 0.5}, "end": {"x": 1, "y": 0.5}}, {
    "text": 3,
    "start": {"x": 3, "y": 0.5},
    "end": {"x": 5, "y": 0.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bbadd9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "B",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "2"}, {"x": 3, "y": 3.5, "text": "3"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bm",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}, {"x": 4, "y": 2.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "B5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "B7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 0.5, "text": "1"}, {
    "x": 3,
    "y": 1.5,
    "text": "3"
  }, {"x": 5, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "B7sus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 2, "y": 1.5, "text": "2"}, {"x": 3, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bm7",
  "crosses": [],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 4, "y": 1.5, "text": "2"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 3, "y": 0.5}}],
  "min": {"text": 2, "x": -0.5, "y": 0.5},
  "max": {"text": 5, "x": -0.5, "y": 3.5}
}, {
  "name": "Bmaj7",
  "crosses": [],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "2"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "B6",
  "crosses": [],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 1, "y": 1.5}}, {
    "text": 3,
    "start": {"x": 2, "y": 3.5},
    "end": {"x": 5, "y": 3.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bsus2",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "2"}, {"x": 3, "y": 3.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bsus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bdim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 0.5, "text": "1"}, {"x": 5, "y": 0.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Baug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 0, "y": 2.5, "text": "3"}, {"x": 1, "y": 1.5, "text": "2"}, {
    "x": 2,
    "y": 0.5,
    "text": "1"
  }, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Bm6",
  "crosses": [],
  "points": [{"x": 4, "y": 2.5, "text": "2"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 1, "y": 1.5}}, {
    "text": 3,
    "start": {"x": 2, "y": 3.5},
    "end": {"x": 3, "y": 3.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "B9",
  "crosses": [],
  "points": [{"x": 2, "y": 0.5, "text": "1"}],
  "lines": [{"text": 2, "start": {"x": 0, "y": 1.5}, "end": {"x": 1, "y": 1.5}}, {
    "text": 3,
    "start": {"x": 3, "y": 1.5},
    "end": {"x": 5, "y": 1.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Badd9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 1.5, "text": "2"}, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Cm",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 4, "y": 0.5, "text": "2"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": 3, "x": -0.5, "y": 1.5},
  "max": {"text": 5, "x": -0.5, "y": 3.5}
}, {
  "name": "C7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 1.5, "text": "2"}, {
    "x": 3,
    "y": 2.5,
    "text": "4"
  }, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C7sus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "2"}, {"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Cm7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "2"}, {"x": 3, "y": 2.5, "text": "3"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Cmaj7",
  "crosses": [],
  "points": [{"x": 0, "y": 2.5, "text": "3"}, {"x": 1, "y": 2.5, "text": "4"}, {"x": 2, "y": 1.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C6",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "4"}, {"x": 2, "y": 1.5, "text": "2"}, {
    "x": 3,
    "y": 1.5,
    "text": "3"
  }, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Csus2",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 4, "y": 0.5, "text": "1"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Csus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "2"}, {"x": 2, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 0.5,
    "text": "1"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Cdim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 1.5, "text": "3"}, {
    "x": 4,
    "y": 0.5,
    "text": "2"
  }, {"x": 5, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Caug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 3, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Cm6",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C9",
  "crosses": [],
  "points": [{"x": 2, "y": 1.5, "text": "1"}],
  "lines": [{"text": 2, "start": {"x": 0, "y": 2.5}, "end": {"x": 1, "y": 2.5}}, {
    "text": 3,
    "start": {"x": 3, "y": 2.5},
    "end": {"x": 5, "y": 2.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C/E",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 1.5, "text": "2"}, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C/G",
  "crosses": [],
  "points": [{"x": 0, "y": 2.5, "text": "3"}, {"x": 1, "y": 2.5, "text": "4"}, {
    "x": 2,
    "y": 1.5,
    "text": "2"
  }, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Cadd9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 3.5, "text": "4"}, {"x": 2, "y": 2.5, "text": "3"}, {"x": 4, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 3, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#m",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "2"}, {"x": 3, "y": 0.5, "text": "1"}, {"x": 4, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": 4, "x": -0.5, "y": 1.5},
  "max": {"text": 6, "x": -0.5, "y": 3.5}
}, {
  "name": "C#7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 1, "y": 3.5, "text": "3"}, {"x": 2, "y": 2.5, "text": "2"}, {
    "x": 3,
    "y": 3.5,
    "text": "4"
  }, {"x": 4, "y": 1.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#7sus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 3.5, "text": "2"}, {"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#m7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 3.5, "text": "2"}, {"x": 3, "y": 3.5, "text": "3"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 1.5}, "end": {"x": 4, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#maj7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 3.5, "text": "4"}, {"x": 2, "y": 2.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 3, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "2"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "1"
  }, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#sus2",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "2"}, {"x": 3, "y": 3.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 4, "x": -0.5, "y": 1.5},
  "max": {"text": 6, "x": -0.5, "y": 3.5}
}, {
  "name": "C#sus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 3, "y": 0.5, "text": "1"}],
  "lines": [{"text": 2, "start": {"x": 4, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#dim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#aug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "4"}, {"x": 3, "y": 1.5, "text": "2"}, {
    "x": 4,
    "y": 1.5,
    "text": "3"
  }, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#m6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#9",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 4, "y": 1.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "C#add9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 4, "x": -0.5, "y": 1.5},
  "max": {"text": 6, "x": -0.5, "y": 3.5}
}, {
  "name": "D",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "1"}, {"x": 4, "y": 2.5, "text": "3"}, {"x": 5, "y": 1.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Dm",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 2.5, "text": "3"}, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "D5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "D7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 0.5, "text": "1"}, {"x": 5, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "D7sus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 0.5, "text": "1"}, {"x": 5, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Dm7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Dmaj7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 3, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "D6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "1"}, {"x": 5, "y": 1.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Dsus2",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Dsus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "1"}, {"x": 4, "y": 2.5, "text": "3"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ddim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 0.5, "text": "1"}, {"x": 5, "y": 0.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Daug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "4"}, {"x": 3, "y": 2.5, "text": "2"}, {
    "x": 4,
    "y": 2.5,
    "text": "3"
  }, {"x": 5, "y": 1.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Dm6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "2"}, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "D9",
  "crosses": [],
  "points": [{"x": 2, "y": 2.5, "text": "1"}],
  "lines": [{"text": 2, "start": {"x": 0, "y": 3.5}, "end": {"x": 1, "y": 3.5}}, {
    "text": 3,
    "start": {"x": 3, "y": 3.5},
    "end": {"x": 5, "y": 3.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "D/A",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 3, "y": 1.5, "text": "1"}, {"x": 4, "y": 2.5, "text": "3"}, {"x": 5, "y": 1.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Dadd9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 5, "x": -0.5, "y": 1.5},
  "max": {"text": 7, "x": -0.5, "y": 3.5}
}, {
  "name": "Eb",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 0, "y": 2.5, "text": "2"}, {"x": 2, "y": 0.5, "text": "1"}, {
    "x": 3,
    "y": 2.5,
    "text": "3"
  }, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebm",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "2"}, {
    "x": 4,
    "y": 3.5,
    "text": "4"
  }, {"x": 5, "y": 1.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Eb5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Eb7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Eb7sus4",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 3.5, "text": "2"}, {"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 4, "x": -0.5, "y": 1.5},
  "max": {"text": 6, "x": -0.5, "y": 3.5}
}, {
  "name": "Ebm7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "4"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebmaj7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}],
  "lines": [{"text": 3, "start": {"x": 3, "y": 2.5}, "end": {"x": 5, "y": 2.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Eb6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 0.5,
    "text": "2"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebsus2",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "0"}, {"x": 3, "y": 2.5, "text": "2"}, {
    "x": 4,
    "y": 3.5,
    "text": "3"
  }, {"x": 5, "y": 0.5, "text": "0"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebsus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}],
  "lines": [{"text": 4, "start": {"x": 4, "y": 3.5}, "end": {"x": 5, "y": 3.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebdim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 1.5, "text": "3"}, {
    "x": 4,
    "y": 0.5,
    "text": "2"
  }, {"x": 5, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebaug",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 0, "y": 2.5, "text": "3"}, {"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebm6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 2.5, "text": "3"}, {"x": 5, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Eb9",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "2"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "1"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Ebadd9",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 6, "x": -0.5, "y": 1.5},
  "max": {"text": 8, "x": -0.5, "y": 3.5}
}, {
  "name": "E",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 1.5, "text": "3"}, {"x": 3, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Em",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "E5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "E7",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 3, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "E7sus4",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 3, "y": 1.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Em7",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Emaj7",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "3"}, {"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 0.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "E6",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 1.5, "text": "3"}, {
    "x": 3,
    "y": 0.5,
    "text": "1"
  }, {"x": 4, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Esus2",
  "crosses": [],
  "points": [{"x": 3, "y": 2.5, "text": "3"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": 2, "x": -0.5, "y": 0.5},
  "max": {"text": 5, "x": -0.5, "y": 3.5}
}, {
  "name": "Esus4",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 1.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Edim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Eaug",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 3, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Em6",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 2, "y": 1.5, "text": "2"}, {"x": 4, "y": 1.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "E9",
  "crosses": [],
  "points": [{"x": 3, "y": 0.5, "text": "1"}, {"x": 4, "y": 2.5, "text": "4"}, {"x": 5, "y": 1.5, "text": "3"}],
  "lines": [{"text": 2, "start": {"x": 1, "y": 1.5}, "end": {"x": 2, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Eadd9",
  "crosses": [],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 3.5, "text": "4"}, {"x": 3, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "E/G#",
  "crosses": [],
  "points": [{"x": 0, "y": 3.5, "text": "4"}, {"x": 1, "y": 1.5, "text": "2"}, {
    "x": 2,
    "y": 1.5,
    "text": "3"
  }, {"x": 3, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "E/B",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 1.5, "text": "3"}, {"x": 3, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 2.5, "text": "4"}, {"x": 3, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Fm",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 0, "y": 0.5, "text": "1"}, {"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F7",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F7sus4",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Fm7",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 4, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Fmaj7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F6",
  "crosses": [],
  "points": [{"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}, {
    "text": 3,
    "start": {"x": 1, "y": 2.5},
    "end": {"x": 2, "y": 2.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Fsus2",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 3.5,
    "text": "4"
  }, {"x": 5, "y": 0.5, "text": "2"}],
  "lines": [],
  "min": {"text": 3, "x": -0.5, "y": 0.5},
  "max": {"text": 6, "x": -0.5, "y": 3.5}
}, {
  "name": "Fsus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Fdim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 0.5, "text": "1"}, {"x": 5, "y": 0.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Faug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "4"}, {"x": 3, "y": 1.5, "text": "2"}, {
    "x": 4,
    "y": 1.5,
    "text": "3"
  }, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Fm6",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "2"}, {"x": 2, "y": 2.5, "text": "3"}, {"x": 4, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F9",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Fadd9",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}, {
    "x": 4,
    "y": 0.5,
    "text": "1"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F/A",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 2, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F/C",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 2.5, "text": "4"}, {"x": 3, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "3"}, {"x": 2, "y": 3.5, "text": "4"}, {"x": 3, "y": 2.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#m",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "3"}, {"x": 2, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}, {"x": 2, "y": 0}],
  "points": [{"x": 0, "y": 1.5, "text": "1"}, {"x": 1, "y": 3.5, "text": "3"}, {"x": 2, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#7",
  "crosses": [],
  "points": [{"x": 1, "y": 2.5, "text": "3"}, {"x": 3, "y": 1.5, "text": "2"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": 2, "x": -0.5, "y": 0.5},
  "max": {"text": 5, "x": -0.5, "y": 3.5}
}, {
  "name": "F#7sus4",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#m7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 2, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#maj7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "4"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#6",
  "crosses": [],
  "points": [{"x": 3, "y": 2.5, "text": "2"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}, {
    "text": 3,
    "start": {"x": 1, "y": 3.5},
    "end": {"x": 2, "y": 3.5}
  }],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#sus2",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 0, "y": 1.5, "text": "2"}, {"x": 1, "y": 3.5, "text": "3"}, {
    "x": 2,
    "y": 3.5,
    "text": "4"
  }, {"x": 3, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#sus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 4, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#dim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 3, "y": 1.5, "text": "3"}, {
    "x": 4,
    "y": 0.5,
    "text": "2"
  }, {"x": 5, "y": 1.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#aug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "4"}, {"x": 3, "y": 2.5, "text": "2"}, {
    "x": 4,
    "y": 2.5,
    "text": "3"
  }, {"x": 5, "y": 1.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#m6",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "2"}, {"x": 2, "y": 3.5, "text": "3"}, {"x": 4, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#9",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "2"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 4, "y": 1.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "F#add9",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "2"}, {
    "x": 4,
    "y": 1.5,
    "text": "1"
  }, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G",
  "crosses": [],
  "points": [{"x": 0, "y": 2.5, "text": "2"}, {"x": 1, "y": 1.5, "text": "1"}, {"x": 5, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gm",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 3, "y": 2.5}, "end": {"x": 5, "y": 2.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G5",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 4, "y": 2.5, "text": "2"}, {"x": 5, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G7",
  "crosses": [],
  "points": [{"x": 0, "y": 2.5, "text": "3"}, {"x": 1, "y": 1.5, "text": "2"}, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G7sus4",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 3, "x": -0.5, "y": 1.5},
  "max": {"text": 5, "x": -0.5, "y": 3.5}
}, {
  "name": "Gm7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 2, "y": 2.5}, "end": {"x": 5, "y": 2.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gmaj7",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "4"}, {"x": 2, "y": 2.5, "text": "2"}, {"x": 3, "y": 2.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 3, "x": -0.5, "y": 1.5},
  "max": {"text": 5, "x": -0.5, "y": 3.5}
}, {
  "name": "G6",
  "crosses": [],
  "points": [{"x": 0, "y": 2.5, "text": "3"}, {"x": 1, "y": 1.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gsus2",
  "crosses": [],
  "points": [{"x": 0, "y": 2.5, "text": "1"}, {"x": 4, "y": 2.5, "text": "2"}, {"x": 5, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gsus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 4, "y": 0.5, "text": "1"}, {"x": 5, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gdim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 1.5, "text": "1"}, {"x": 3, "y": 2.5, "text": "3"}, {
    "x": 4,
    "y": 1.5,
    "text": "2"
  }, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gaug",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 0.5, "text": "1"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gm6",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 0.5, "text": "1"}, {"x": 2, "y": 1.5, "text": "2"}],
  "lines": [{"text": 3, "start": {"x": 3, "y": 2.5}, "end": {"x": 5, "y": 2.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G9",
  "crosses": [],
  "points": [{"x": 0, "y": 2.5, "text": "4"}, {"x": 1, "y": 1.5, "text": "2"}, {
    "x": 3,
    "y": 1.5,
    "text": "3"
  }, {"x": 5, "y": 0.5, "text": "1"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "Gadd9",
  "crosses": [],
  "points": [{"x": 0, "y": 1.5, "text": "2"}, {"x": 1, "y": 0.5, "text": "1"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": 2, "x": -0.5, "y": 0.5},
  "max": {"text": 5, "x": -0.5, "y": 3.5}
}, {
  "name": "G/B",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "1"}, {"x": 4, "y": 2.5, "text": "3"}, {"x": 5, "y": 2.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G/D",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 5, "y": 2.5, "text": "3"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#m",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 1, "y": 1.5, "text": "2"}, {"x": 2, "y": 0.5, "text": "1"}],
  "lines": [{"text": 4, "start": {"x": 3, "y": 3.5}, "end": {"x": 5, "y": 3.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#5",
  "crosses": [],
  "points": [{"x": 3, "y": 0.5, "text": "1"}, {"x": 4, "y": 3.5, "text": "3"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 5, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#7sus4",
  "crosses": [],
  "points": [{"x": 1, "y": 3.5, "text": "3"}, {"x": 3, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 0, "y": 1.5}, "end": {"x": 5, "y": 1.5}}],
  "min": {"text": 4, "x": -0.5, "y": 1.5},
  "max": {"text": 6, "x": -0.5, "y": 3.5}
}, {
  "name": "G#m7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 2, "y": 3.5}, "end": {"x": 5, "y": 3.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#maj7",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 5, "y": 2.5, "text": "3"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 5, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#sus2",
  "crosses": [],
  "points": [{"x": 0, "y": 3.5, "text": "2"}, {"x": 4, "y": 3.5, "text": "3"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 1, "y": 0.5}, "end": {"x": 3, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#sus4",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 4, "y": 1.5, "text": "2"}, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 3, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#dim",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 0.5, "text": "1"}, {"x": 5, "y": 0.5, "text": "2"}],
  "lines": [],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#aug",
  "crosses": [{"x": 0, "y": 0}],
  "points": [{"x": 0, "y": 3.5, "text": "4"}, {"x": 1, "y": 2.5, "text": "3"}, {"x": 2, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 3, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#m6",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 5, "y": 0.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 3, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#9",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 3, "y": 2.5, "text": "3"}, {"x": 5, "y": 1.5, "text": "2"}],
  "lines": [{"text": 1, "start": {"x": 2, "y": 0.5}, "end": {"x": 4, "y": 0.5}}],
  "min": {"text": "", "x": -1, "y": -1},
  "max": {"text": "", "x": -1, "y": -1}
}, {
  "name": "G#add9",
  "crosses": [{"x": 0, "y": 0}, {"x": 1, "y": 0}],
  "points": [{"x": 2, "y": 3.5, "text": "3"}, {"x": 3, "y": 2.5, "text": "2"}, {
    "x": 4,
    "y": 1.5,
    "text": "1"
  }, {"x": 5, "y": 3.5, "text": "4"}],
  "lines": [],
  "min": {"text": 4, "x": -0.5, "y": 1.5},
  "max": {"text": 6, "x": -0.5, "y": 3.5}
}];